var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportsTabIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 1.76624H14.1665C16.4124 1.76624 18.2329 3.58766 18.2329 5.83362V14.1666C18.2329 16.4126 16.4124 18.233 14.1665 18.233H5.8335C3.58754 18.233 1.76611 16.4126 1.76611 14.1666V5.83362C1.76611 3.58766 3.58754 1.76624 5.8335 1.76624ZM5.8335 3.23303C4.39756 3.23303 3.23291 4.39768 3.23291 5.83362V14.1666C3.23291 15.6026 4.39756 16.7662 5.8335 16.7662H14.1665C15.6025 16.7662 16.7661 15.6026 16.7661 14.1666V5.83362C16.7661 4.39768 15.6025 3.23303 14.1665 3.23303H5.8335Z",
    fill: "#4F4F4F",
    stroke: "white",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 10.933C6.26208 10.933 5.93377 11.2615 5.93359 11.6664V13.3334C5.93359 13.7384 6.26197 14.0668 6.66699 14.0668C7.07186 14.0666 7.40039 13.7383 7.40039 13.3334V11.6664C7.40021 11.2616 7.07176 10.9332 6.66699 10.933Z",
    fill: "#4F4F4F",
    stroke: "white",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 5.93298C12.9286 5.93298 12.6003 6.26153 12.6001 6.66638V13.3334C12.6001 13.7384 12.9285 14.0668 13.3335 14.0668C13.7384 14.0666 14.0669 13.7383 14.0669 13.3334V6.66638C14.0667 6.26163 13.7382 5.93316 13.3335 5.93298Z",
    fill: "#4F4F4F",
    stroke: "white",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.43298C9.59509 8.43298 9.26678 8.76151 9.2666 9.16638V13.3334C9.2666 13.7384 9.59498 14.0668 10 14.0668C10.4049 14.0666 10.7334 13.7383 10.7334 13.3334V9.16638C10.7332 8.76162 10.4048 8.43316 10 8.43298Z",
    fill: "#4F4F4F",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsTabIcon);
export default __webpack_public_path__ + "static/media/ReportsTabIcon.98c233a5046e28e46a1a5e0e888e3044.svg";
export { ForwardRef as ReactComponent };